import { render, staticRenderFns } from "./HtmlText.vue?vue&type=template&id=6e6b580d"
import script from "./HtmlText.vue?vue&type=script&lang=js"
export * from "./HtmlText.vue?vue&type=script&lang=js"
import style0 from "./HtmlText.vue?vue&type=style&index=0&id=6e6b580d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports